// action types

const OPEN = 'FUNNEL_CANCEL_MODAL_OPEN';
const CLOSE = 'FUNNEL_CANCEL_MODAL_CLOSE';
const SET_ON_ACCEPT_CALLBACK = 'FUNNEL_CANCEL_MODAL_SET_ON_ACCEPT_CALLBACK';

// reducer

const initialState = {
  eventScreenText: '',
  isModalOpen: false,
  onAcceptCallback: null,
};

const funnelCancelModal = (state = initialState, action) => {
  switch (action.type) {
    case OPEN:
      return { ...state, eventScreenText: action.payload, isModalOpen: true };
    case CLOSE:
      return { ...state, isModalOpen: false };
    case SET_ON_ACCEPT_CALLBACK:
      return { ...state, onAcceptCallback: action.payload };
    default:
      return { ...state };
  }
};

export default funnelCancelModal;

// action creators

export const openFunnelCancelModal = (payload = '') => dispatch => dispatch({
  payload,
  type: OPEN,
});

export const closeFunnelCancelModal = () => dispatch => dispatch({ type: CLOSE });

export const setOnAcceptCallbackFunnelCancelModal = payload => dispatch => dispatch({
  payload,
  type: SET_ON_ACCEPT_CALLBACK,
});
